import { render, staticRenderFns } from "./IndividualRegistration.vue?vue&type=template&id=180bebcf&scoped=true"
import script from "./IndividualRegistration.vue?vue&type=script&lang=js"
export * from "./IndividualRegistration.vue?vue&type=script&lang=js"
import style0 from "./IndividualRegistration.vue?vue&type=style&index=0&id=180bebcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180bebcf",
  null
  
)

export default component.exports